export default __webpack_public_path__ + "static/media/680.a3d0671a.png";